import { Component } from '@angular/core';

@Component({
  selector: 'cbs-settings-wrap',
  template: `<router-outlet></router-outlet>`,
})
export class SettingsWrapComponent {

}
